// removed by extract-text-webpack-plugin
module.exports = {"header":"header__2MqSo","active":"active__27Q54","menuButton":"menuButton__2J6q5","sidenav":"sidenav__dVm1a","opened":"opened__x6pRN"};


//////////////////
// WEBPACK FOOTER
// ./components/header/style.css
// module id = u3et
// module chunks = 2